import React, { useEffect, useState } from "react";
import API_URL from "../../services/api";
import "./ManageEvents.css";

const ManageEvents = () => {
  const [events, setEvents] = useState([]);

  const [form, setForm] = useState({
    title: "",
    description: "",
    event_date: "",
  });

  // ============================
  // FETCH EVENTS
  // ============================

  const fetchEvents = async () => {
    try {
      const res = await fetch(`${API_URL}/api/events`);
      const data = await res.json();

      setEvents(data);
    } catch (err) {
      console.log("FETCH EVENTS ERROR:", err);
    }
  };

  useEffect(() => {
    fetchEvents();
  }, []);

  // ============================
  // HANDLE INPUT
  // ============================

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  // ============================
  // ADD EVENT
  // ============================

  const addEvent = async () => {
    if (!form.title.trim() || !form.event_date) {
      alert("Event title and date are required.");
      return;
    }

    try {
      const res = await fetch(`${API_URL}/api/events/add`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(form),
      });

      const data = await res.json();

      if (!res.ok) {
        alert(data.message || "Failed to add event.");
        return;
      }

      alert("Event Added Successfully!");

      setForm({
        title: "",
        description: "",
        event_date: "",
      });

      fetchEvents();
    } catch (err) {
      console.log("ADD EVENT ERROR:", err);
      alert("Server error. Please try again.");
    }
  };

  // ============================
  // DELETE EVENT
  // ============================

  const deleteEvent = async (event_id) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this event?"
    );

    if (!confirmDelete) return;

    try {
      const res = await fetch(
        `${API_URL}/api/events/${event_id}`,
        {
          method: "DELETE",
        }
      );

      const data = await res.json();

      if (!res.ok) {
        alert(data.message || "Failed to delete event.");
        return;
      }

      alert("Event Deleted Successfully.");

      fetchEvents();
    } catch (err) {
      console.log("DELETE EVENT ERROR:", err);
      alert("Server error. Please try again.");
    }
  };

  // ============================
  // FORMAT DATE
  // ============================

  const formatDate = (date) => {
    if (!date) return "N/A";

    return new Date(date).toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  return (
    <div className="events-page">

      {/* ============================
          PAGE HEADER
      ============================ */}

      <div className="events-header">
        <div>
          <h1>Manage Events</h1>

          <p>
            Create and manage library events and activities.
          </p>
        </div>

        <div className="event-count">
          <span>{events.length}</span>
          <small>Total Events</small>
        </div>
      </div>

      {/* ============================
          ADD EVENT FORM
      ============================ */}

      <div className="event-form-card">

        <div className="section-heading">
          <div className="section-icon">📅</div>

          <div>
            <h2>Add New Event</h2>
            <p>
              Enter the details of the new library event.
            </p>
          </div>
        </div>

        <div className="event-form">

          {/* TITLE */}

          <div className="form-group">
            <label>Event Title</label>

            <input
              type="text"
              name="title"
              placeholder="Enter event title"
              value={form.title}
              onChange={handleChange}
            />
          </div>

          {/* DATE */}

          <div className="form-group">
            <label>Event Date</label>

            <input
              type="date"
              name="event_date"
              value={form.event_date}
              onChange={handleChange}
            />
          </div>

          {/* DESCRIPTION */}

          <div className="form-group full-width">
            <label>Event Description</label>

            <textarea
              name="description"
              placeholder="Write event description..."
              value={form.description}
              onChange={handleChange}
              rows="5"
            />
          </div>

        </div>

        <div className="form-actions">

          <button
            className="add-event-btn"
            onClick={addEvent}
          >
            <span>+</span>
            Add Event
          </button>

        </div>

      </div>

      {/* ============================
          EVENTS SECTION
      ============================ */}

      <div className="existing-events">

        <div className="events-section-header">

          <div>
            <h2>Existing Events</h2>

            <p>
              View and manage all library events.
            </p>
          </div>

          <div className="events-total">
            {events.length} Events
          </div>

        </div>

        {/* ============================
            EVENT LIST
        ============================ */}

        {events.length === 0 ? (

          <div className="no-events">

            <div className="no-events-icon">
              📅
            </div>

            <h3>No Events Found</h3>

            <p>
              Add your first library event using
              the form above.
            </p>

          </div>

        ) : (

          <div className="event-grid">

            {events.map((event) => (

              <div
                className="event-card"
                key={event.event_id}
              >

                <div className="event-card-top">

                  <div className="event-calendar">
                    📅
                  </div>

                  <span className="event-status">
                    Upcoming
                  </span>

                </div>

                <h3 className="event-title">
                  {event.title}
                </h3>

                <p className="event-description">
                  {event.description ||
                    "No description provided."}
                </p>

                <div className="event-details">

                  <div className="event-detail">

                    <span className="detail-icon">
                      📅
                    </span>

                    <div>
                      <small>Date</small>

                      <strong>
                        {formatDate(event.event_date)}
                      </strong>
                    </div>

                  </div>

                  <div className="event-detail">

                    <span className="detail-icon">
                      🆔
                    </span>

                    <div>
                      <small>Event ID</small>

                      <strong>
                        {event.event_id}
                      </strong>
                    </div>

                  </div>

                </div>

                <button
                  className="delete-event-btn"
                  onClick={() =>
                    deleteEvent(event.event_id)
                  }
                >
                  🗑 Delete Event
                </button>

              </div>

            ))}

          </div>

        )}

      </div>

    </div>
  );
};

export default ManageEvents;